import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index";
import LayoutAdmin from "@/layout/admin";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/web/login')
  },
  {
    path: "/",
    name: "Home",
    component: Layout,
    redirect: "/personal",
    children: [
      {
        path: "/personal",
        name: "personal",
        component: () => import("@/views/web/personal"),
        meta: {
          name: '个人信息',
          icon: ''
        }
      },
      {
        path: "/information",
        name: "information",
        component: () => import("@/views/web/information"),
        meta: {
          name: '企业信息',
          icon: ''
        }
      },
      {
        path: "/product_management",
        name: "product_management",
        component: () => import("@/views/web/product_management"),
        meta: {
          name: '产品管理',
          icon: ''
        }
      },
      {
        path: "/user_management",
        name: "user_management",
        component: () => import("@/views/web/user_management"),
        meta: {
          name: '用户管理',
          icon: ''
        }
      },
    ]
  },

  // ---------------------- 后台
  {
    path: '/admin',
    name: 'adminLogin',
    component: () => import('@/views/admin/login')
  },
  {
    path: "/",
    name: "Home",
    component: LayoutAdmin,
    redirect: "/admin/index",
    children: [
      {
        path: "/admin/individual_users",
        name: "individual_users",
        component: () => import("@/views/admin/individual_users"),
        meta: {
          name: '用户列表',
          icon: ''
        }
      },
      {
        path: "/admin/individual_users/user_detail",
        name: "user_detail",
        component: () => import("@/views/admin/individual_users/user_detail"),
        meta: {
          name: '个人用户详情',
          icon: ''
        }
      },
      {
        path: "/admin/enterprise_users",
        name: "enterprise_users",
        component: () => import("@/views/admin/enterprise_users"),
        meta: {
          name: '公司管理',
          icon: ''
        }
      },
      {
        path: "/admin/enterprise_users/enterprise_detail",
        name: "enterprise_detail",
        component: () => import("@/views/admin/enterprise_users/enterprise_detail"),
        meta: {
          name: '公司管理详情',
          icon: ''
        }
      },
      {
        path: "/admin/auth_manage",
        name: "auth_manage",
        component: () => import("@/views/admin/auth_manage"),
        meta: {
          name: '授权管理',
          icon: ''
        }
      },
      {
        path: "/admin/order",
        name: "order",
        component: () => import("@/views/admin/order"),
        meta: {
          name: '订单管理',
          icon: ''
        }
      },
      {
        path: "/admin/product",
        name: "product",
        component: () => import("@/views/admin/product"),
        meta: {
          name: '产品管理',
          icon: ''
        }
      },
    ]
  }
];

const router = new VueRouter({
  mode: 'hash', // 或 'hash'  'history'
  // base: process.env.BASE_URL,
  routes
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next()
});

export default router;
